// src/routes/brandsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Brands from '../pages/brands/Brands';
import CreateBrand from '../pages/brands/CreateBrand';
import EditBrand from '../pages/brands/EditBrand';
import ProtectedRoute from '../components/global/ProtectedRoute';

const brandsRoutes = (
    <>
        {/* Brands List */}
        <Route
            path="/brands"
            element={
                <ProtectedRoute requiredPermission="brands_list">
                    <Brands />
                </ProtectedRoute>
            }
        />

        {/* Create Brand */}
        <Route
            path="/brands/create"
            element={
                <ProtectedRoute requiredPermission="brands_create">
                    <CreateBrand />
                </ProtectedRoute>
            }
        />

        {/* Edit Brand */}
        <Route
            path="/brands/:id/edit"
            element={
                <ProtectedRoute requiredPermission="brands_edit">
                    <EditBrand />
                </ProtectedRoute>
            }
        />
    </>
);

export default brandsRoutes;
